import { Form } from 'semantic-ui-react';
import styled from 'styled-components';
import { colors } from '@playbookux/playbook-web-core';

const { ERROR_RED, GRAY_TEXT } = colors;

// fix
const Label = styled.p`
  &&&&& {
  font-size: ${(props) => (props.fontSize ? props.fontSize : '18px')};
  font-weight: ${(props) => (props.weight ? props.weight : 'normal')};
  margin-bottom: 5px;
  margin-right: 15px;
  color: ${(props) => (props.color ? props.color : 'black')};
  color: ${(props) => props.error && ERROR_RED};
  white-space: nowrap;
    @-moz-document url-prefix() {
      letter-spacing: -1px;
    }
  }
`;

const FormInput = styled(Form.Input)`
  &&& {
    ${(props) => props.inline && 'display: inline-block'};
    float: right;
    width: 100%;
    border-radius: 0;
    ${(props) => props.audience && `
      input {
        border-radius: 0;
        text-align: right;
        color: ${GRAY_TEXT}
      }
      input:focus {
        border-radius: 0;
        color: #555555;
      }`
}
  }
`;

const Flex = styled.div`
  ${(props) => props.inline && 'display: flex'};
  ${(props) => props.inline && 'text-align: center'};
  ${(props) => props.inline && 'align-items: center'};
`;

export {
  Label,
  FormInput,
  Flex,
};
